import axios from 'axios';
import getAuthToken from '../utils/cookie';

export const updateUsersCompanyStatus = async (user, role) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/company/user/status/`;
  const tok = getAuthToken();
  const response = await axios.put(
    apiUrl,
    {
      user,
      role
    },
    {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    }
  );
  return response;
};


export const updateUsersDefaultGroup = async (user, group) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/user/default/group/`;
  const tok = getAuthToken();
  const response = await axios.put(
    apiUrl,
    {
      user,
      group
    },
    {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    }
  );
  return response;
};

export const getUsersInCompany = async () => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/all/user/in/company/`;
  const tok = getAuthToken();
  const response = await axios.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${tok}`
    }
  });
  return response;
};
